import React from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { StyleSheet, Text, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import theme from 'shared/styles/theme';

const DaysHeader = () => {
  const { t: translatedText } = useTranslation('calendar', {
    keyPrefix: 'calendar',
  });
  return (
    <View>
      <View style={styles.container}>
        <Text style={styles.textStyle}>{translatedText('sun')}</Text>
        <Text style={styles.textStyle}>{translatedText('mon')}</Text>
        <Text style={styles.textStyle}>{translatedText('tue')}</Text>
        <Text style={styles.textStyle}>{translatedText('wed')}</Text>
        <Text style={styles.textStyle}>{translatedText('thu')}</Text>
        <Text style={styles.textStyle}>{translatedText('fri')}</Text>
        <Text style={styles.textStyle}>{translatedText('sat')}</Text>
      </View>
      <HairLineDivider />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.s,
  },
  textStyle: {
    ...theme.typography.body.xs,
    color: theme.color.text.primary,
    textAlign: 'center',
  },
});

export default DaysHeader;
